<template>
    <b-form-row>
        <b-modal v-model="showModal" size="xl" button-size="sm" ref="finder" hide-footer :title="prefix + title">
            <Unidade-Administrativa-List v-if="!isOrnograma"
                @onDblClickUnidadeAdministrativa="unidadeAdministrativaSelect" :title="prefix + title + ' >'" />

            <HierarquiaUnidadeAdministrativaList @rowSelect="unidadeAdministrativaSelect" v-if="isOrnograma"
                :idFinderLocal="id + '-list'" :title="''" :prefix="prefix + title" :idPaiProp="idPai">
            </HierarquiaUnidadeAdministrativaList>

        </b-modal>

        <lg-form-input-finder v-if="!isModal" @handleClean="unidadeAdministrativaSelect" v-model="localValue"
            fieldDescription="descricao" :label="label" invalidFeedback="Unidade administrativa deve ser informada!"
            description="" :showClear="podeApagarDepartamento && !disabled" :disabled="disabled">
            <template #prepend>
                <b-button @click="show" class="btn-input-finder" pressed v-if="podeMudarDepartamento"
                    :disabled="disabled">   
                    <b-icon icon="search" />
                </b-button>
            </template>

            <template #notInUnidadeAdministrativa v-if="mostrarNotInUnidadeAdministrativa">
                <b-button :id="'notInUnidadeAdministrativa' + id" class="btnRound" @click="mudarSimNao"
                    :variant="!notInUnidadeAdministrativa ? 'success' : 'secondary'" :disabled="disabled">
                    <b-icon icon="check" />
                </b-button>
                <b-tooltip :target="'notInUnidadeAdministrativa' + id"
                    title="Marque para pesquisar apenas a selecionada" triggers="hover"></b-tooltip>
            </template>

            <template #ornograma v-if="ornograma">
                <b-button :id="'ornograma' + id" class="btnRound btnOrnograma" @click="abrirModalOrnograma"
                    :disabled="disabled" style="margin-top: -5px">
                    <b-icon icon="bounding-box" />
                </b-button>
                <b-tooltip :target="'ornograma' + id" title="Ornograma das Unidades Administrativa"
                    triggers="hover"></b-tooltip>

            </template>
        </lg-form-input-finder>
        <LgFinderPageOrnograma @selecionarOrnograma="selecionarOrnograma" :codsDepartamentos="codsDepartamentos"
            @close="fecharModalOrnograma" v-if="mostrarModalOrnograma" :prefix="prefix"></LgFinderPageOrnograma>

    </b-form-row>
</template>

<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue"
import UnidadeAdministrativaList from "@/modules/cadastros/unid-administrativa/UnidadeAdministrativaList.vue"
import LgFinderPageOrnograma from "@/components/Finders/LgFinderPageOrnograma.vue";
import HierarquiaUnidadeAdministrativaList from "@/modules/cadastros/hierarquia-unidade-administrativa/HierarquiaUnidadeAdministrativaList.vue";

export default {
    components: { LgFinderPageOrnograma, LgFormInputFinder, UnidadeAdministrativaList, HierarquiaUnidadeAdministrativaList },

    name: "LgFinderPageUnidadeAdministrativa",
    props: {
        isOrnograma: {
            type: Boolean,
            default: false
        },
        idPai:
            { type: Number, default: null },

        codsDepartamentos: {
            type: String,
            default: "",
        },
        id: String,
        isModal: {
            type: Boolean,
            default: false
        },
        onselect: Function,
        value: Object,
        prefix: {
            type: String,
            default: "",
        },
        podeApagarDepartamento: {
            type: Boolean,
            default: true,
        },
        ornograma: {
            type: Boolean,
            default: false,
        },
        mostrarNotInUnidadeAdministrativa: {
            type: Boolean,
            default: false,
        },

        podeMudarDepartamento: {
            type: Boolean,
            default: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: "Unidade Administrativa",
        },
        label: {
            type: String,
            default: "Unidade Administrativa:",
        },
    },

    data() {
        return {
            mostrarModalOrnograma: false,

            notInUnidadeAdministrativa: false,
            showModal: false,
            localValue: this.value,
        }
    },
    watch: {
        value(newValue) {
            this.localValue = newValue
        },
        localValue(newValue) {
            this.$emit("input", newValue)
        },
    },

    methods: {
        selecionarOrnograma(departamentos) {
            this.localValue = departamentos.length  == 1? departamentos[0].descricao: {descricao: "DIVERSAS"}
            this.showModal = false;
            this.$emit("selecionarOrnograma", departamentos.map(d => d.id).join(","));
        },
        abrirModalOrnograma() {
            this.mostrarModalOrnograma = true;
        },
        fecharModalOrnograma() {
            this.mostrarModalOrnograma = false;
        },

        mudarSimNao() {
            this.notInUnidadeAdministrativa = !this.notInUnidadeAdministrativa;
            this.$emit("notInUnidadeAdministrativa", this.notInUnidadeAdministrativa)

        },
        show() {
            this.showModal = true;
        },

        unidadeAdministrativaSelect(item) {
            this.localValue = item;
            this.showModal = false;
            this.$emit("onselect", item);
        },
    },
}
</script>


<style scoped>
.btn-secondary {
    background-color: gray;
    border-color: gray;
    color: white;
}

.btnOrnograma {
    background-color: transparent;
    color: black;
    border-color: transparent;
    font-size: 14px;

}

.btnRound {
    border-radius: 25px !important;
    width: 20px;
    padding: 1px;
    margin-left: 10px !important;

}
</style>